<div class="performance-report" #scrollContainer (scroll)="onScroll()">
  <!-- 0. Standardized Premium Loader (Matches OTP Verification) -->
  <div class="premium-loader-overlay" *ngIf="isLoading">
    <div class="premium-spinner">
      <div class="spinner-ring"></div>
      <i class="bi bi-cpu-fill spinner-icon"></i>
    </div>
    <p>ANALYZING PERFORMANCE...</p>
  </div>

  <header class="report-header" *ngIf="!isLoading">
    <div class="header-left">
      <button class="btn-back-v4" (click)="goBack()"
        style="background: none; border: none; color: #64748B; font-size: 1.25rem; margin-right: 1rem; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 50%; transition: background 0.2s;"
        onmouseover="this.style.background='#F1F5F9'" onmouseout="this.style.background='none'">
        <i class="bi bi-arrow-left"></i>
      </button>
      <div class="brand-text-v4">
        <span class="report-subtitle-v4">Interview Report</span>
        <span class="report-attempt-meta-v4" *ngIf="totalAttempts > 1">
          {{ evaluationData?.candidate_name || 'Candidate' }} · Attempt {{ currentAttemptNumber }} of {{ totalAttempts }}
        </span>
      </div>
    </div>

    <div class="header-right">
      <div class="attempts-switcher-v4" *ngIf="attemptsList && attemptsList.length > 1">
        <button type="button" class="attempt-pill-v4"
          *ngFor="let att of attemptsList"
          [class.active]="att.attempt_number === currentAttemptNumber"
          (click)="switchAttempt(att)">
          #{{ att.attempt_number }}
        </button>
      </div>
      <button class="btn-share-v4" (click)="shareReport()">
        <span>Share Report</span>
      </button>
    </div>
  </header>

  <div class="content-container" *ngIf="!isLoading">
    <ng-container *ngIf="evaluationData; else noData">

      <!-- 2. Top Hero Row -->
      <div class="hero-grid-v4">
        <!-- Profile Card -->
        <div class="hero-card-white profile-card-v4">
          <div class="profile-header-v4">
            <div class="avatar-v4">{{ evaluationData.candidate_name?.slice(0, 1) || 'P' }}{{
              evaluationData.candidate_name?.split(' ')?.[1]?.slice(0,1) || '' }}</div>
            <div class="profile-info-v4">
              <h1>{{ evaluationData.candidate_name || 'Priya Sharma' }}</h1>
              <p>{{ role || 'Senior Science Teacher Candidate' }}</p>
              <!-- <p class="company-sub-v4" *ngIf="company"><i class="bi bi-building"></i> {{ company }}</p> -->
              <div class="contact-links-v4">
                <span><i class="bi bi-envelope"></i> {{ evaluationData.candidate_email || 'priya.sharma@email.com'
                  }}</span>
                <span><i class="bi bi-telephone"></i> {{ evaluationData.candidate_phone || '' }}</span>
              </div>
            </div>
          </div>

          <div style="margin-top: 1.5rem; margin-bottom: 1.5rem;" *ngIf="evaluationData.resume_url">
            <a [href]="evaluationData.resume_url" target="_blank"
              style="display: flex; justify-content: center; align-items: center; gap: 0.5rem; padding: 0.75rem; background-color: #F8FAFC; color: #4F46E5; border-radius: 0.75rem; text-decoration: none; font-weight: 700; font-size: 0.875rem; border: 1px dashed #CBD5E1; transition: all 0.2s;"
              onmouseover="this.style.backgroundColor='#EEF2FF'; this.style.borderColor='#A5B4FC'"
              onmouseout="this.style.backgroundColor='#F8FAFC'; this.style.borderColor='#CBD5E1'">
              <i class="bi bi-file-earmark-person-fill" style="font-size: 1.1rem;"></i> View Candidate Resume
            </a>
          </div>

          <div class="stats-row-v4">
            <div class="stat-box-v4">
              <span class="s-label">Started</span>
              <span class="s-val">{{ getTimeOnly(startTime) }}</span>
            </div>
            <div class="stat-box-v4">
              <span class="s-label">Ended</span>
              <span class="s-val">{{ getTimeOnly(endTime) }}</span>
            </div>
            <div class="stat-box-v4">
              <span class="s-label">Duration</span>
              <span class="s-val">{{ duration }} min</span>
            </div>
          </div>
        </div>

        <!-- Summary Gradient Card -->
        <div class="hero-card-gradient summary-card-v4">
          <div class="summary-inner-v4">
            <div class="summary-text-col">
              <div class="summary-top-v4">
                <h3><i class="bi bi-stars"></i> Interview Summary</h3>
                <span class="ai-pill-v4">AI Generated</span>
              </div>
              <p class="summary-p-v4">{{ voiceAnalysis?.overall_summary || (evaluationData.candidate_name + '
                demonstrated strong subject knowledge and clear communication, with a structured teaching approach. Some
                hesitation noted on reflective questions.') }}</p>

            </div>

            <div class="score-card-premium-v4">
              <div class="glass-inner-v4">
                <div class="ring-v4">
                  <svg viewBox="0 0 100 100">
                    <defs>
                      <linearGradient id="scoreGradientSummary" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color:#4F46E5; stop-opacity:1" />
                        <stop offset="100%" style="stop-color:#7C3AED; stop-opacity:1" />
                      </linearGradient>
                    </defs>
                    <circle class="r-bg" cx="50" cy="50" r="45"></circle>
                    <circle class="r-fill-v4" cx="50" cy="50" r="45"
                      [style.stroke-dashoffset]="283 - (totalScore * 2.83)"></circle>
                  </svg>
                  <div class="r-text-v4">
                    <span class="val-v4-big">{{ integerTotalScore }}</span>
                    <span class="max-v4-sub">/ 100</span>
                  </div>
                </div>
              </div>
              <span class="score-label-v4-bottom">Final Score</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 3. Overall Performance Bar -->
      <div class="overall-performance-v4 report-card-v4" id="section-performance"
           (mouseenter)="onSectionHover('performance')" (mouseleave)="onSectionLeave('performance')">
        <div class="perf-top-v4" (click)="toggleSection('performance')" style="margin-bottom: 1.5rem;">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-graph-up"></i>
            </div>
            <h3>Overall Performance</h3>
            <span class="perf-badge-v4" [ngClass]="getScoreClass(totalScore)">{{ getRatingText(totalScore) }}</span>
          </div>
          <button class="btn-toggle-v4">
            <i class="bi" [ngClass]="collapsedSections['performance'] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
          </button>
        </div>
        <div class="collapsible-content" [class.collapsed]="collapsedSections['performance']">
          <div class="collapsible-inner">
            <div class="perf-score-line-v4">
              <span class="main-score-v4">{{ integerTotalScore }}<small>/ 100</small></span>
              <span class="score-desc-v4">{{ feedbackLabel }}</span>
            </div>
            <div class="linear-progress-v4">
              <div class="progress-track-v4">
                <div class="progress-fill-v4" [style.width.%]="totalScore"></div>
              </div>
              <div class="progress-labels-v4">
                <span>Below Average</span>
                <span>Average</span>
                <span>Good</span>
                <span>Excellent</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 4. Performance Breakdown -->
      <section class="report-card-v4" id="section-breakdown"
               (mouseenter)="onSectionHover('breakdown')" (mouseleave)="onSectionLeave('breakdown')">
        <div class="section-header-v4" (click)="toggleSection('breakdown')">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-activity"></i>
            </div>
            <h3 class="section-title-v4" style="margin:0;">Performance Breakdown</h3>
          </div>
          <button class="btn-toggle-v4">
            <i class="bi" [ngClass]="collapsedSections['breakdown'] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
          </button>
        </div>
        <div class="collapsible-content" [class.collapsed]="collapsedSections['breakdown']">
          <div class="collapsible-inner">
            <div class="skills-grid-v4" style="margin-bottom:0;">
              <!-- Row 1: Teacher-specific skills (only when is_teacher: true) -->
              <ng-container *ngIf="isTeacherRole">
                <div class="skill-card-v4" *ngFor="let item of teacherPerformanceData">
                  <div class="skill-header-v4">
                    <div class="skill-icon-v4"><i class="bi" [ngClass]="item.icon"></i></div>
                    <span class="skill-rating-v4" [ngClass]="item.rating">{{ item.rating | titlecase }}</span>
                  </div>
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.subtitle }}</p>
                  <div class="score-pill-mini">Score: {{ item.score }}/10</div>
                </div>
              </ng-container>

              <!-- Dynamic Performance Breakdown Row -->
              <div class="skill-card-v4" *ngFor="let item of performanceData">
                <div class="skill-header-v4">
                  <div class="skill-icon-v4"><i class="bi" [ngClass]="item.icon"></i></div>
                  <span class="skill-rating-v4" [ngClass]="item.rating">{{ item.rating | titlecase }}</span>
                </div>
                <h4>{{ item.title }}</h4>
                <p>{{ item.subtitle }}</p>
                <div class="score-pill-mini">Score: {{ item.score }}/10</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 5. Proctoring & Integrity V4 -->
      <section *ngIf="!isB2cPractice" class="report-card-v4" id="section-integrity"
               (mouseenter)="onSectionHover('integrity')" (mouseleave)="onSectionLeave('integrity')">
        <div class="section-header-v4" (click)="toggleSection('integrity')">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-shield-check"></i>
            </div>
            <h3 class="section-title-v4" style="margin:0;">
              Proctoring & Integrity Report
            </h3>
            <span class="suspicious-pill-v4">Suspicious Activity</span>
          </div>
          <button class="btn-toggle-v4">
            <i class="bi" [ngClass]="collapsedSections['integrity'] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
          </button>
        </div>

        <div class="collapsible-content" [class.collapsed]="collapsedSections['integrity']">
          <div class="collapsible-inner">
            <p class="integrity-summary-v4" style="margin-bottom: 2rem;">We detected {{ alertStats.critical }}
              high-severity events during the interview.</p>

            <div class="severity-grid-v4">
              <div class="sev-item-v4 high">
                <div class="sev-icon-circle"><i class="bi bi-exclamation-octagon"></i></div>
                <div class="sev-text">
                  <span class="sev-label">High Severity</span>
                  <span class="sev-val">{{ alertStats.critical }} events</span>
                </div>
              </div>
              <div class="sev-item-v4 medium">
                <div class="sev-icon-circle"><i class="bi bi-exclamation-triangle"></i></div>
                <div class="sev-text">
                  <span class="sev-label">Medium</span>
                  <span class="sev-val">{{ alertStats.warnings }} event</span>
                </div>
              </div>
              <div class="sev-item-v4 low">
                <div class="sev-icon-circle"><i class="bi bi-check-circle"></i></div>
                <div class="sev-text">
                  <span class="sev-label">Low</span>
                  <span class="sev-val">{{ alertStats.info }} events</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 5.1 Proctoring Alerts Timeline -->
      <section *ngIf="!isB2cPractice" class="report-card-v4" style="padding: 0; overflow: hidden;" id="section-timeline"
               (mouseenter)="onSectionHover('timeline')" (mouseleave)="onSectionLeave('timeline')">
        <div class="section-header-v4" (click)="toggleSection('timeline')"
          style="padding: 1.5rem 2.5rem; margin-bottom: 0; border-bottom: 1px solid var(--slate-100);">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-activity"></i>
            </div>
            <h3 class="section-title-v4" style="margin:0;">
              Proctoring Alerts Timeline
            </h3>
          </div>
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="t-filters" (click)="$event.stopPropagation()">
              <div class="filter-group">
                <i class="bi bi-funnel"></i>
                <select class="filter-select-v4" (change)="onEventFilterChange($event)">
                  <option value="ALL">All Events</option>
                  <option *ngFor="let eventType of uniqueEvents" [value]="eventType">{{ eventType }}</option>
                </select>
              </div>
              <div class="filter-group">
                <i class="bi bi-shield-exclamation"></i>
                <select class="filter-select-v4" (change)="onSeverityFilterChange($event)">
                  <option value="ALL">All Severity</option>
                  <option *ngFor="let sev of uniqueSeverities" [value]="sev">{{ sev | titlecase }}</option>
                </select>
              </div>
            </div>
            <button class="btn-toggle-v4">
              <i class="bi" [ngClass]="collapsedSections['timeline'] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
            </button>
          </div>
        </div>

        <div class="collapsible-content" [class.collapsed]="collapsedSections['timeline']">
          <div class="collapsible-inner">
            <div class="timeline-table-scroll-v4">
              <table class="timeline-table-v4">
                <thead>
                  <tr>
                    <th style="width: 120px;">Time</th>
                    <th style="width: 140px;">Snapshot</th>
                    <th style="width: 180px;">Event</th>
                    <th style="width: 100px;">Severity</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let log of filteredAlertLogs">
                    <td class="td-time-v4">{{ log.time }}</td>
                    <td>
                      <div class="snapshot-v4" [ngClass]="log.event.toLowerCase().replace(' ', '-')">
                        <img *ngIf="log.url" [src]="log.url" class="snapshot-img-v4" alt="Snapshot">
                        <div class="snapshot-overlay-v4">{{ log.event }}</div>
                      </div>
                    </td>
                    <td class="td-event-v4">{{ log.event }}</td>
                    <td><span class="sev-pill-v4" [ngClass]="log.severity.toLowerCase()">{{ log.severity }}</span></td>
                    <td class="td-desc-v4">{{ log.reason }}</td>
                  </tr>
                  <tr *ngIf="filteredAlertLogs.length === 0">
                    <td colspan="5" class="text-center py-4 text-muted">No alerts found for selected filters.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <!-- 5.2 Audio Analysis V4 -->
      <section class="audio-analysis-section-v4 report-card-v4" id="section-audio"
               (mouseenter)="onSectionHover('audio')" (mouseleave)="onSectionLeave('audio')">
        <div class="section-header-v4" (click)="toggleSection('audio')">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-soundwave"></i>
            </div>
            <h3 class="section-title-v4" style="margin:0;">Audio Analysis</h3>
          </div>
          <button class="btn-toggle-v4">
            <i class="bi" [ngClass]="collapsedSections['audio'] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
          </button>
        </div>
        <div class="collapsible-content" [class.collapsed]="collapsedSections['audio']">
          <div class="collapsible-inner">
            <div class="audio-grid-v4">
              <div class="audio-card-v4" *ngFor="let card of voiceAnalysisCards" [ngClass]="card.color">
                <div class="ac-header">
                  <div class="ac-icon"><i class="bi" [ngClass]="card.icon"></i></div>
                  <div class="ac-score">
                    <span class="score-num">{{ card.score }}</span>
                    <span class="score-max">/10</span>
                  </div>
                </div>
                <div class="ac-body">
                  <h4>{{ card.title }}</h4>
                  <p>{{ card.feedback }}</p>
                </div>
                <div class="ac-footer">
                  <div class="ac-progress-bar">
                    <div class="ac-progress" [style.width.%]="card.score * 10"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Overall Audio Summary -->
            <div class="audio-summary-banner-v4" *ngIf="voiceAnalysis?.overall_summary">
              <div class="as-icon-v4"><i class="bi bi-stars"></i></div>
              <div class="as-content-v4">
                <span class="as-label-v4">Vocal Performance Summary</span>
                <p class="as-text-v4">{{ voiceAnalysis.overall_summary }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 5.3 Interview Recording -->
      <section *ngIf="!isB2cPractice" class="report-card-v4" id="section-recording"
               (mouseenter)="onSectionHover('recording')" (mouseleave)="onSectionLeave('recording')">
        <div class="section-header-v4" (click)="toggleSection('recording')">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-camera-video"></i>
            </div>
            <h3 class="section-title-v4" style="margin:0;">
              Interview Recording
            </h3>
          </div>
          <div style="display: flex; align-items: center; gap: 1rem;">
            <a *ngIf="screenRecordUrl" href="javascript:void(0)" class="btn-download-v4"
              (click)="downloadRecording($event, screenRecordUrl)"
              style="text-decoration: none; padding: 0.5rem 1rem; border-radius: 0.5rem; border: 1px solid var(--slate-200); background: white; color: var(--slate-700); font-weight: 500; font-size: 0.875rem; display: flex; align-items: center; gap: 0.5rem; transition: all 0.2s; box-shadow: 0 1px 2px rgba(0,0,0,0.05);"
              onmouseover="this.style.background='#F8FAFC'" onmouseout="this.style.background='white'">
              <i class="bi bi-download"></i> Download
            </a>
            <button class="btn-toggle-v4">
              <i class="bi" [ngClass]="collapsedSections['recording'] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
            </button>
          </div>
        </div>

        <div class="collapsible-content" [class.collapsed]="collapsedSections['recording']">
          <div class="collapsible-inner">
            <div class="video-container-v4">
              <div class="video-preview-overlay-v4" *ngIf="screenRecordUrl" (click)="openVideoLightbox()">
                <div class="play-btn-v4">
                  <i class="bi bi-play-fill"></i>
                </div>
                <span>Click to view recording</span>
              </div>
              <video [src]="safeRecordingUrl" *ngIf="screenRecordUrl" class="preview-video-v4"></video>
              <div class="video-placeholder-v4" *ngIf="!screenRecordUrl">
                <i class="bi bi-play-circle"></i>
                <p>Interview Recording Unavailable</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 6. Question Navigator -->
      <section class="report-card-v4" id="section-questions"
               (mouseenter)="onSectionHover('questions')" (mouseleave)="onSectionLeave('questions')">
        <div class="section-header-v4" (click)="toggleSection('questions')">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-list-check"></i>
            </div>
            <h3 class="section-title-v4" style="margin:0;">
              Question Navigator
            </h3>
          </div>
          <button class="btn-toggle-v4">
            <i class="bi" [ngClass]="collapsedSections['questions'] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
          </button>
        </div>
        <div class="collapsible-content" [class.collapsed]="collapsedSections['questions']">
          <div class="collapsible-inner">
            <div class="question-accordion-v3">
              <div class="q-item-v3" *ngFor="let q of questions; let i = index">
                <div class="q-header-v3" (click)="selectedQuestion = (selectedQuestion === i ? -1 : i)">
                  <div class="q-num-v3">{{ i + 1 }}</div>
                  <div class="q-text-v3">{{ q.question }}</div>
                  <div class="q-meta-v3">
                    <span class="q-rating" [ngClass]="'rating-' + getQuestionScoreClass(q.score)">{{
                      getQuestionRatingText(q.score) }}</span>
                    <i class="bi bi-chevron-down ms-2"></i>
                  </div>
                </div>

                <div class="q-body-v3" *ngIf="selectedQuestion === i">
                  <div class="response-summary">
                    <span class="b-label">Candidate Response</span>
                    <p>{{ q.answer }}</p>
                  </div>

                  <!-- Removed Improved Answer -->

                  <div class="feedback-blocks-v3">
                    <div class="f-block strengths">
                      <span class="f-label"><i class="bi bi-check-circle"></i> Strengths</span>
                      <ul>
                        <li *ngFor="let point of q.good">{{ point }}</li>
                      </ul>
                    </div>
                    <div class="f-block recommendations">
                      <span class="f-label"><i class="bi bi-exclamation-triangle"></i> Skill Gaps</span>
                      <ul>
                        <li *ngFor="let point of q.skill_gaps">{{ point }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 7. Executive Insights -->
      <section class="report-card-v4 insights-section-v4">
        <div class="section-header-v4">
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div class="section-icon-box-v4">
              <i class="bi bi-briefcase"></i>
            </div>
            <h3 class="section-title-v4" style="margin:0;">Executive Insights</h3>
          </div>
          <span class="ai-pill-v4" style="color: var(--slate-400); border-color: var(--slate-200);">Final Summary</span>
        </div>

        <div class="insights-grid-v4">
          <!-- Key Strengths Box -->
          <div class="insight-box-v4 strengths">
            <div class="ib-header-v4">
              <i class="bi bi-award-fill"></i>
              <h4>Key Strengths</h4>
            </div>
            <ul class="ib-list-v4">
              <li *ngFor="let s of strengths">
                <i class="bi bi-check2-circle"></i>
                {{ s }}
              </li>
            </ul>
          </div>

          <!-- Skill Gaps Box -->
          <div class="insight-box-v4 focus">
            <div class="ib-header-v4">
              <i class="bi bi-exclamation-triangle-fill"></i>
              <h4>Skill Gaps</h4>
            </div>
            <ul class="ib-list-v4">
              <li *ngFor="let f of skill_gaps">
                <i class="bi bi-dash-circle"></i>
                {{ f }}
              </li>
            </ul>
          </div>

          <!-- Final Recommendation Box -->
          <div class="insight-box-v4 recommendation">
            <div class="ib-header-v4">
              <i class="bi bi-star-fill"></i>
              <h4>Hiring Recommendation</h4>
            </div>
            <div class="improvement-path-v4">
              <ul class="roadmap-list-v4">
                <li *ngFor="let step of nextSteps">
                  <i class="bi bi-arrow-right-short"></i>
                  {{ step.text }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </ng-container>

    <ng-template #noData>
      <div class="text-center py-5">
        <div class="fs-1 text-muted mb-3"><i class="bi bi-info-circle"></i></div>
        <h3>No Report Data Found</h3>
        <button class="btn-share-gradient mt-3" (click)="goBack()">Go Back</button>
      </div>
    </ng-template>
  </div>
</div>

<!-- Image Lightbox -->
<div class="lightbox-v4" *ngIf="selectedImage()" (click)="closeLightbox()">
  <div class="lightbox-content-v4" (click)="$event.stopPropagation()">
    <button class="btn-close-lightbox-v4" (click)="closeLightbox()">
      <i class="bi bi-x"></i>
    </button>
    <img [src]="selectedImage()" alt="Snapshot Full View">
  </div>
</div>

<!-- Video Lightbox (Premium Player) -->
<div class="video-lightbox-v4" *ngIf="selectedVideo()" (click)="closeVideoLightbox()">
  <div class="video-player-modal-v4" (click)="$event.stopPropagation()" #videoContainer>
    <button class="btn-close-player-v4" (click)="closeVideoLightbox()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="player-content-v4">
      <video #lightboxVideo [src]="selectedVideo()!" (timeupdate)="onTimeUpdate($event)"
        (loadedmetadata)="onMetadataLoaded($event)" (play)="isPlaying.set(true)" (pause)="isPlaying.set(false)"
        (ended)="isPlaying.set(false)" autoplay></video>

      <!-- Center Play Overlay (visible on pause) -->
      <div class="player-center-play-v4" *ngIf="!isPlaying()" (click)="togglePlayPause()">
        <i class="bi bi-play-fill"></i>
      </div>

      <!-- Player Controls -->
      <div class="player-controls-v4" (click)="$event.stopPropagation()">
        <!-- Progress Bar -->
        <div class="player-progress-v4">
          <input type="range" class="seek-slider-v4" [value]="currentTime()" [max]="videoDuration()" step="0.1"
            (input)="onSeekPreview($event)" (change)="onSeekEnd($event)"
            [style.background-size]="(currentTime() / videoDuration() * 100) + '% 100%'">
        </div>

        <div class="player-bottom-row-v4">
          <div class="controls-left-v4">
            <button class="ctrl-btn-v4" (click)="seekVideo(-10)" title="Backward 10s">
              <i class="bi bi-arrow-counterclockwise"></i>
            </button>
            <button class="ctrl-btn-v4 main-play-v4" (click)="togglePlayPause()">
              <i class="bi" [ngClass]="isPlaying() ? 'bi-pause-fill' : 'bi-play-fill'"></i>
            </button>
            <button class="ctrl-btn-v4" (click)="seekVideo(10)" title="Forward 10s">
              <i class="bi bi-arrow-clockwise"></i>
            </button>
            <div class="time-display-v4">
              <span>{{ formatTime(currentTime()) }}</span>
              <span class="time-sep">/</span>
              <span>{{ formatTime(videoDuration()) }}</span>
            </div>
          </div>

          <div class="controls-right-v4">
            <div class="volume-control-v4">
              <button class="ctrl-btn-v4" (click)="toggleMute()">
                <i class="bi" [ngClass]="isMuted() || volume() === 0 ? 'bi-volume-mute-fill' : 'bi-volume-up-fill'"></i>
              </button>
              <input type="range" class="volume-slider-v4" [value]="volume()" min="0" max="1" step="0.05"
                (input)="onVolumeChange($event)" [style.background-size]="(volume() * 100) + '% 100%'">
            </div>
            <button class="ctrl-btn-v4" (click)="toggleFullScreen()" title="Full Screen">
              <i class="bi bi-fullscreen"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>